// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import 'babel-polyfill';
import App from './App';
import router from './router';
import VueI18n from 'vue-i18n';
import VueAnalytics from 'vue-analytics';
import VueScrollTo from 'vue-scrollto';
import Meta from 'vue-meta';
import Vuetify from 'vuetify';
import { DataTables, DataTablesServer } from 'vue-data-tables';
import enLocale from 'element-ui/lib/locale/lang/en';
import esLocale from 'element-ui/lib/locale/lang/es';
import caLocale from 'element-ui/lib/locale/lang/ca';
import oLocalStorage from '@/services/objectLocalStorage';
import dateFilters from './filters/dateFilters';
import _ from 'lodash';
import { DatePicker, Checkbox, CheckboxGroup, CheckboxButton, Transfer, RadioGroup, RadioButton, InputNumber, Loading } from 'element-ui';
import ElementLocale from 'element-ui/lib/locale';
import localeService from '@/services/localeService';

import './assets/sass/element-variables.scss';

import './assets/stylus/main.styl';

// Loading http(axios) interceptors that sets the Authorization Headers and Token Renewal
import axiosInterceptors from './config/axiosInterceptors';

import VueWaypoint from 'vue-waypoint';
import VeeValidate from 'vee-validate';

import moment from 'moment';
import { extendMoment } from 'moment-range';

import colors from 'vuetify/es5/util/colors';

extendMoment(moment);

axiosInterceptors.init();

Vue.config.productionTip = false;

let messages = {
  'ca-ES': Object.assign(require('./locales/messages_ca-ES.json'), caLocale),
  'en-GB': Object.assign(require('./locales/messages_en-GB.json'), enLocale),
  'es-ES': Object.assign(require('./locales/messages_es-ES.json'), esLocale),
  'es-CL': Object.assign(require('./locales/messages_es-CL.json'), esLocale)
};

Vue.use(VueI18n);

Vue.use(DatePicker);
Vue.use(Checkbox);
Vue.use(CheckboxGroup);
Vue.use(CheckboxButton);
Vue.use(Transfer);
Vue.use(Loading);
Vue.use(RadioGroup);
Vue.use(RadioButton);
Vue.use(InputNumber);

Vue.use(VueWaypoint);
Vue.use(VeeValidate);
Vue.use(VueAnalytics, {
  id: 'UA-81902136-1',
  router
});
Vue.use(VueScrollTo);
Vue.use(Vuetify, {
  theme: {
    primary: colors.cyan.base,
    secondary: colors.cyan.lighten3,
    accent: colors.lightGreen.lighten1,
    error: colors.red.base,
    warning: colors.yellow.base,
    info: colors.blue.base,
    success: colors.green.base
  }
});

Vue.use(DataTables);
Vue.use(DataTablesServer);
Vue.use(Meta);

_.each(dateFilters, (value, key) => {
  Vue.filter(key, value);
});

if (process.env.NODE_ENV === 'production') {
  Vue.config.devtools = false;
  Vue.config.debug = false;
  Vue.config.silent = true;
}

let start = () => {
  let defaultLangSelected = oLocalStorage.get('langSelected') !== null ? oLocalStorage.get('langSelected') : process.env.LANGUAGES['en-GB'];

  const i18n = new VueI18n({
    locale: defaultLangSelected.langIso,
    messages
  });

  ElementLocale.i18n((key, value) => i18n.t(key, value));

  /* eslint-disable no-new */
  new Vue({
    el: '#app-main-container',
    router,
    i18n,
    template: '<App/>',
    components: {
      App
    }
  });
};

if (oLocalStorage.get('langSelected') === null && (process.env.NODE_ENV === 'production' || process.env.NODE_ENV === 'preproduction')) {
  localeService.getCountryAws(start);
} else {
  start();
}



// WEBPACK FOOTER //
// ./src/main.js